"use strict";

var KEYCODES = {
  esc: 27
};

module.exports = KEYCODES;


//////////////////
// WEBPACK FOOTER
// ./~/reactjs-components/lib/constants/Keycodes.js
// module id = 1294
// module chunks = 2